import styled from 'styled-components';

import ArrowLeft from 'assets/arrow-left';

export const ArrowIcon = styled(ArrowLeft)`
  width: 15px;
  height: 15px;
  margin-right: 5px;
`;
